import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, json, useParams } from "react-router-dom";
import { ColorRing } from "react-loader-spinner";
import { Modal } from "rsuite";
import Seo from "../components/Seo";
import LoderView from "../components/LoderView";

const SingleProduct = () => {
  const { id } = useParams();
  const [cat, setCat] = useState([]);
  const [productData, setProductData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [modelImg, setModelImg] = useState();
  const [subCat, setSubCat] = useState([]);
  const [catClick, setCatClick] = useState("");

  // console.log(catClick, "===============================");
  // const [foundCat, setfoundCat] = useState([]);
  //console.log("sub cat===========" + subCat);

  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  useEffect(() => {
    getProductData();
  }, [id, catClick]);

  const getData = async () => {
    try {
      const res = await axios.get(
        `https://test.bioversalremedies.com/bioversal_remedies_admin/api/catebysub/${id}`
      );
      console.log("catebysub", res.data);
      setCat(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getProductData = async () => {
    //console.log(subcategoryName, "Sub Category Nameee");
    setLoading(true);
    console.log(id);
    try {
      const res = await axios.get(
        //`https://bioraiz.in/bioraiz_admin/api/catebypro/${id}`
        `https://test.bioversalremedies.com/bioversal_remedies_admin/api/subbypro/${id}`
      );
      console.log("subbypro", res.data);
      if (catClick.length > 0) {
        const filteredData = res.data.filter(
          (item) => item.subcategory_name === catClick
        );
        setProductData(filteredData);
      } else {
        setProductData(res.data);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // console.log(productData, "ddddd");
  const handleOpen = (img) => {
    // console.log("text" + img);
    setOpen(true);
    setModelImg(img);
  };

  const handleClose = () => setOpen(false);

  const handlesubcat = async (subcategoryName) => {
    // console.log(subcategoryName, "Sub Category Name");
    // setSelectedSubcategory(subcategoryName);
    // setLoading(true);
    // try {
    //   const res = await axios.get(
    //     //`https://bioraiz.in/bioraiz_admin/api/catebypro/${id}`
    //     `https://bioraiz.in/bioraiz_admin/api/subbypro/Syrup`
    //   );
    //   console.log(res.data, "==============================================");
    //   setSubCat(res.data);
    //   setLoading(false);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
  };

  return (
    <section>
      <Modal open={open} onClose={handleClose} size={"sm"}>
        <button
          className="text-danger"
          style={{ position: "absolute", top: "15px", right: "22px" }}
          onClick={handleClose}
        >
          <i className="fas fa-times"></i>
        </button>
        <Modal.Body>
          <img
            src={modelImg}
            alt="Image"
            style={{ width: "100%", height: "400px" }}
          />
        </Modal.Body>
      </Modal>

      <div className="container-fluid mt-5 p-0">
        <div
          className="bg_cont__45__single_product ban__nerrr d-flex flex-column"
          style={{ backgroundBlendMode: "difference" }}
        >
          <h2 style={{ color: "#004960", zIndex: "99" }}>{id}</h2>
         
        </div>
      </div>

      <div className="container">
        {isLoading ? (
          <div>
            <LoderView />
          </div>
        ) : productData.length === 0 ? (
          <div>
            <h3 className="notfound_text">No Products Found</h3>
          </div>
        ) : (
          <div className="container">
            <div className="row justify-content-start">
              {productData.map((product) => (
                <div
                  key={product.id}
                  className="col-md-3 col-sm-6 mb-4 col-12 d-flex justify-content-center p-0"
                >
                  <div className="product-card">
                    <Link
                      to={`/products/${product.name}?category=${product.category}`}
                    >
                      <img
                        src={product.image}
                        alt=""
                        className="product-image"
                      />
                      <div className="product-info">
                        <div style={{ textAlign: "start" }}>
                          <h2 className="product-name">{product?.name}</h2>
                          <hr />
                          <p className="product-composition">
                            {product?.composition}
                          </p>
                        </div>
                        <Link
                          className="read-more-btn"
                          to={`/products/${product.name}?category=${product.category}`}
                        >
                          <div>Read More</div>
                        </Link>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* <div className="container">
        <div className="mt-10 text-center">
          {isLoading ? (
            <div>
             <LoderView />
            </div>
          ) : productData.length === 0 ? (
            <div>
              <h3 className="notfound_text">No Products Found</h3>
            </div>
          ) : (
            <>
              <table className="prod__tab_4 d-none d-md-table">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Composition</th>
                    <th>Packing</th>
                    <th>Catalog</th>
                    <th>Product</th>
                  </tr>
                </thead>
                <tbody>
                  {productData.map((item) => (
                    <tr key={item.id}>
                      <td>{item?.name}</td>
                      <td>{item?.composition}</td>
                      <td>
                        {item.size} {item.package_type}
                      </td>
                      <td>
                        <button
                          className="open_modal_btn"
                          onClick={() => handleOpen(item.image)}
                        >
                          Open
                        </button>
                      </td>
                      <td>
                        <button
                          className="open_modal_btn"
                          onClick={() => handleOpen(item.image)}
                        >
                          Open
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {productData.map((item, index) => (
                <table className="prod__tab_4 hideondesktop" key={index}>
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Composition</th>
                      <th>Packing</th>
                      <th>Catalog</th>
                      <th>Product</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr key={item.id}>
                      <td>{item?.name}</td>
                      <td>{item?.composition}</td>
                      <td>
                        {item.size} {item.package_type}
                      </td>
                      <td>
                        <button onClick={() => handleOpen(item.image)}>
                          Open Modal
                        </button>
                      </td>
                      <td>
                        <button onClick={() => handleOpen(item.image)}>
                          Open Modal
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              ))}
            </>
          )}
        </div>
      </div> */}
    </section>
  );
};

export default SingleProduct;
